import { DashboardSidebar } from "@/components/layout/dashboard-sidebar";
import { DashboardHeader } from "@/components/layout/dashboard-header";
import {
  DashboardShellProvider,
  useDashboardShell,
} from "@/lib/layout/use-dashboard-shell";

interface DashboardShellProps {
  children: React.ReactNode;
}

function DashboardShellInner({ children }: DashboardShellProps) {
  const { isSidebarCollapsed, isMobile } = useDashboardShell();
  const marginClass = isMobile
    ? ""
    : isSidebarCollapsed
      ? "md:ms-16"
      : "md:ms-64";

  return (
    <div className="h-screen bg-background text-foreground flex font-sans overflow-hidden">
      <DashboardSidebar />
      <main
        className={`flex-1 ${marginClass} w-full flex flex-col overflow-hidden`}
        style={{ transition: "margin-inline-start 0.3s ease" }}
      >
        <DashboardHeader />
        <div className="flex-1 overflow-y-auto">{children}</div>
      </main>
    </div>
  );
}

export function DashboardShell({ children }: DashboardShellProps) {
  return (
    <DashboardShellProvider>
      <DashboardShellInner>{children}</DashboardShellInner>
    </DashboardShellProvider>
  );
}
